
import { securityQuestionsActionType } from './../constants/ApiConstants';

const initialState = {
  loaderBusinessToken: false,
  businessNameCheck: false,
  businessCheckMessage: null,
  authenticating: false,
  errorMessage: null,
  errorMessageForInvalidPass : null,
  response: {},
  securityQuestionLink : null,
  resetSecurityQuestions : null,
  successMessage : null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case securityQuestionsActionType.check_business_name.REQUEST:
    return {
      ...state,
      loaderBusinessToken: true,
      businessNameCheck: false,
      businessCheckMessage: null,
    };
  case securityQuestionsActionType.check_business_name.SUCCESS:
    return {
      ...state,
      loaderBusinessToken: false,
      businessNameCheck: payload.access_token,
      businessCheckMessage: payload.businessCheckMessage,
      organizationDetails: payload.organizationDetails,
    };
  case securityQuestionsActionType.save_login_questions.REQUEST:
    return {
      ...state,
      authenticating: true,
      errorMessage:'',
    };
  case securityQuestionsActionType.save_login_questions.SUCCESS:
    return {
      ...state,
      authenticating: false,
      response: payload.response,
      errorMessage: payload.errorMessage,
    };
  case securityQuestionsActionType.save_login_questions.FAILURE:
    return {
      ...state,
      authenticating: false,
      response: payload.response,
      errorMessage: payload.errorMessage,
    };
  case securityQuestionsActionType.post_reset_security_question.REQUEST:
    return {
      ...state,
      loaderBusinessToken: true,
      securityQuestionLink : null,
      successMessage : null
    }
  case securityQuestionsActionType.post_reset_security_question.SUCCESS:
    return {
      ...state,
      loaderBusinessToken: false,
      securityQuestionLink : payload,
      successMessage : payload.message,
    }
  case securityQuestionsActionType.get_reset_security_question.REQUEST:
    return {
      ...state,
      loaderBusinessToken: true,
      resetSecurityQuestions : null,
      errorMessageForInvalidPass : null
    }
  case securityQuestionsActionType.get_reset_security_question.SUCCESS:
    const{message , statusCode} = payload
    const resMessage = (message && statusCode == 401) ? message : null;
    return {
      ...state,
      loaderBusinessToken: false,
      resetSecurityQuestions : payload,
      errorMessageForInvalidPass: resMessage,
    }
  case securityQuestionsActionType.remove_error_message.SUCCESS:
    return {
      ...state,
      errorMessage: "",
    }
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/reducers/SecurityQuestionsReducer.js